import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M14.756 6.187v4.92a2.663 2.663 0 0 1-2.66 2.65h-3.22v-1.5H12.1a1.159 1.159 0 0 0 1.16-1.15v-4.92a1.161 1.161 0 0 0-1.16-1.16H8.866a.74.74 0 0 1-.53-.21l-1.33-1.33h-2.92a1.152 1.152 0 0 0-1.16 1.15V9h-1.5V4.637a2.657 2.657 0 0 1 2.66-2.65h3.22a.74.74 0 0 1 .53.21l1.34 1.33H12.1a2.672 2.672 0 0 1 2.656 2.66Zm-9.05 2.77a.764.764 0 0 0-1.06.02.755.755 0 0 0 .02 1.06l.61.59h-3.04a.75.75 0 0 0 0 1.5h3.05l-.62.6a.754.754 0 0 0-.02 1.06.776.776 0 0 0 .54.23.734.734 0 0 0 .52-.21l1.95-1.89a.725.725 0 0 0 .23-.54.758.758 0 0 0-.23-.54Z';
const draw24px = 'M18,20.45H13.17V19H18a2.1,2.1,0,0,0,2.1-2.1V9.48A2.1,2.1,0,0,0,18,7.37H13.17a.75.75,0,0,1-.53-.22l-2.12-2.1H6a2.1,2.1,0,0,0-2.1,2.1v6.53H2.39V7.15A3.6,3.6,0,0,1,6,3.55h4.84a.71.71,0,0,1,.53.22l2.12,2.1H18a3.61,3.61,0,0,1,3.6,3.61v7.37A3.6,3.6,0,0,1,18,20.45ZM11.1,16.72,8.17,13.9a.75.75,0,0,0-1,1.08l1.58,1.53H3.22a.75.75,0,1,0,0,1.5H8.71L7.13,19.54a.76.76,0,0,0,0,1.07.75.75,0,0,0,.54.22.71.71,0,0,0,.52-.21L11.1,17.8a.76.76,0,0,0,.22-.54A.77.77,0,0,0,11.1,16.72Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const FolderArrowRightIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'folderArrowRight'));
FolderArrowRightIcon.displayName = 'FolderArrowRightIcon';
FolderArrowRightIcon.propTypes = Icon.propTypes;
FolderArrowRightIcon.renderIcon = props => /*#__PURE__*/React.createElement(FolderArrowRightIcon, props);
export default FolderArrowRightIcon;
//# sourceMappingURL=FolderArrowRightIcon.js.map